import { Suspense, useState } from 'react'
import { Input } from 'antd'
import type { AgGridReactProps } from 'ag-grid-react'
import SearchIcon from '@mui/icons-material/Search'

import AgGridReactLazy from 'common/components/LazyLoaded/AgGridReact'
import AdminStatusRenderer from 'features/UserManagement/Components/Tables/CellRenderer/StatusRenderer'

const UserManagementPage = () => {
  const columnDefs: AgGridReactProps['columnDefs'] = [
    {
      headerName: 'First Name',
      field: 'firstName',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Last Name',
      field: 'lastName',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Email',
      field: 'email',
      getQuickFilterText: () => '',
      resizable: true
    },
    {
      headerName: 'Role',
      field: 'role',
      getQuickFilterText: () => '',
      resizable: true
    },
    {
      headerName: 'Status',
      field: 'status',
      getQuickFilterText: () => '',
      cellRenderer: AdminStatusRenderer,
      resizable: true
    }
  ]

  const rowData = [
    {
      firstName: 'person A',
      lastName: 'person A',
      email: 'person_A@email.com',
      role: 'Admin',
      status: true
    },
    {
      firstName: 'admin B',
      lastName: 'admin B',
      email: 'admin_B@email.com',
      role: 'Admin',
      status: true
    },
    {
      firstName: 'user C',
      lastName: 'user C',
      email: 'user_C@email.com',
      role: 'User',
      status: true
    }
  ]

  const [quickFilterText, setQuickFilterText] = useState('')

  return (
    <div className='m-2 flex h-full flex-1 flex-col'>
      <div className='mb-2 mt-4 flex w-80 border-gray-700 bg-white'>
        <Input
          prefix={<SearchIcon />}
          className='rounded-3xl'
          placeholder='Search'
          onChange={(evt) => {
            setQuickFilterText(evt.target.value)
          }}
          pattern='^[A-Za-z0-9][A-Za-z0-9\s]*$'
        />
      </div>
      <div className='ag-theme-lighthouse flex-1'>
        <Suspense fallback='Loading table...'>
          <AgGridReactLazy
            quickFilterText={quickFilterText}
            columnDefs={columnDefs}
            defaultColDef={{
              suppressHeaderMenuButton: true,
              flex: 1
            }}
            rowData={rowData}
            rowClass='border-b-gray-300'
          />
        </Suspense>
      </div>
    </div>
  )
}

export default UserManagementPage
